"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalyticsResponse = exports.useAnalyticsLoadV2 = exports.useAnalyticsLoadBasic = void 0;
var react_1 = require("react");
var AnalyticsHelper_1 = require("./AnalyticsHelper");
/** pushes analytics payload only once */
function useAnalyticsLoadBasic(payload) {
    (0, react_1.useEffect)(function () {
        AnalyticsHelper_1.AnalyticsHelper.push(payload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.useAnalyticsLoadBasic = useAnalyticsLoadBasic;
/** pushes analytics payload of given key only once */
function useAnalyticsLoadV2(analyticsHelper, key, ready) {
    if (ready === void 0) { ready = true; }
    var _a = (0, react_1.useState)(false), pushed = _a[0], setPushed = _a[1];
    (0, react_1.useEffect)(function () {
        if (pushed || !ready) {
            return;
        }
        analyticsHelper.push(key);
        setPushed(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ready]);
}
exports.useAnalyticsLoadV2 = useAnalyticsLoadV2;
/** analytic response helper hook  */
function useAnalyticsResponse(analyticsHelper, key) {
    var _a = (0, react_1.useState)(0), startTime = _a[0], setStartTime = _a[1];
    return {
        setStartToNow: function () { return setStartTime(Date.now()); },
        pushResponseGA: function () {
            analyticsHelper.push(key, startTime);
        },
    };
}
exports.useAnalyticsResponse = useAnalyticsResponse;
//# sourceMappingURL=analyticHooks.js.map